export default __webpack_public_path__ + "static/media/agricultural-1.72cbc1b3.jpg";